export default __webpack_public_path__ + "static/media/ClubHLogo.a42e617c.png";